<div class="mediations">
    <div class="mediations__item" *ngFor="let mediation of mediations; trackBy: trackByIndex">
        <img
            *ngIf="mediation === MediationEngine.BIDON; else defaultIcon"
            [ngSrc]="buildIconMediationEngine(mediation)"
            height="15"
            width="20"
        />
        <ng-template #defaultIcon>
            <svg-image [name]="buildIconMediationEngine(mediation)"></svg-image>
        </ng-template>
    </div>
</div>
